/* eslint import/prefer-default-export: 0 */
import axios from '../utils/api'

import CONFIG from '../config'
import { isCachedItem } from '../utils/caching'
import {
  LIST_USERS_REQUEST, LIST_USERS_RESPONSE, LIST_USERS_RESPONSE_ERROR,
  FETCH_USER_REQUEST, FETCH_USER_RESPONSE, FETCH_USER_RESPONSE_ERROR,
  UPDATE_ALERT_SUBSCRIPTION_REQUEST, UPDATE_ALERT_SUBSCRIPTION_RESPONSE,
  FETCH_ALERT_SUBSCRIPTION_REQUEST, FETCH_ALERT_SUBSCRIPTION_RESPONSE,
} from '../constants'

export function listUsers(query = '') {
  return (dispatch, getState) => {
    if (isCachedItem(getState().userSearches, query)) {
      return
    }
    dispatch({ type: LIST_USERS_REQUEST })

    axios.get(`${CONFIG.apiBase}/users?q=${query}`).then((response) => {
      dispatch({
        type: LIST_USERS_RESPONSE,
        users: response.data.body,
        query,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error)
      dispatch({ type: LIST_USERS_RESPONSE_ERROR })
    })
  }
}

export function listOrganizationUsers(organizationId, query = '') {
  return (dispatch) => {
    dispatch({ type: LIST_USERS_REQUEST })

    axios.get(`${CONFIG.apiBase}/organizations/${organizationId}/users?q=${query}`).then((response) => {
      dispatch({
        type: LIST_USERS_RESPONSE,
        users: response.data.body,
        query,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error)
      dispatch({ type: LIST_USERS_RESPONSE_ERROR })
    })
  }
}

export function fetchUser(id) {
  return (dispatch, getState) => {
    if (isCachedItem(getState().users, id)) {
      return
    }
    dispatch({ type: FETCH_USER_REQUEST, id })

    axios.get(`${CONFIG.apiBase}/users/${id}`).then((response) => {
      dispatch({
        type: FETCH_USER_RESPONSE,
        id,
        user: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error)
      dispatch({ type: FETCH_USER_RESPONSE_ERROR })
    })
  }
}

export function currentUser() {
  return fetchUser('me')
}

export function fetchSubscription(communityId) {
  return (dispatch) => {
    dispatch({
      type: FETCH_ALERT_SUBSCRIPTION_REQUEST,
      id: communityId,
    })
    axios.get(`${CONFIG.apiBase}/communities/${communityId}/subscription`).then((response) => {
      dispatch({
        type: FETCH_ALERT_SUBSCRIPTION_RESPONSE,
        id: communityId,
        user: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function updateSubscription(communityId, subscribed) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_ALERT_SUBSCRIPTION_REQUEST,
      id: communityId,
      subscribed,
    })
    axios.post(`${CONFIG.apiBase}/communities/${communityId}/subscription`, { subscribed }).then((response) => {
      dispatch({
        type: UPDATE_ALERT_SUBSCRIPTION_RESPONSE,
        id: communityId,
        user: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}
